export const LATEST_PRIVACY_POLICY_VERSION = '20251113';
export const LATEST_TERMS_OF_SERVICE_VERSION = '20250513';
export const LATEST_TELEHEALTH_CONSENT_VERSION = '20250513';
export const LATEST_SUNNYSIDE_SUBSCRIPTION_TERMS_VERSION = '20250513';
